import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import ReactHtmlParser from 'react-html-parser'
import Typography from 'components/atoms/Typography'
import { startsWithHttp } from 'helpers/strings'
import CustomButton from 'components/atoms/CustomButton'
import { get } from 'lodash'
import InfoCard from 'components/molecules/InfoCard'
import { renderIndexItemClass, userCheckMobileScreen } from 'helpers/tools'
import SectionTitle from 'components/molecules/SectionTitle'
import { useHistory } from 'react-router-dom'

import './InformationGrid.scss'

function InformationGrid(props) {
  const isMobile = userCheckMobileScreen()
  const history = useHistory()
  const { data } = props
  const title = get(data, 'title')
  const id = get(data, 'id')
  const description = get(data, 'description.value')
  const button = get(data, 'button.entity')
  const buttonTitle = button ? get(button, 'link.title') : ''
  const buttonLinkUrl = button ? get(button, 'link.url.path') : ''
  const firstItemRender = get(data, 'first')
  const lastItemRender = get(data, 'last')
  const themeClasses = get(data, 'theme.entity.classes')
  const sectionTitle = get(data, 'sectionTitle')

  return (
    <Container
      id={id}
      fluid="fluid"
      className={`information-grid ${renderIndexItemClass(firstItemRender, lastItemRender)} ${themeClasses}`}
    >
      <Container>
        {sectionTitle && <SectionTitle title={sectionTitle} className="mb-4" />}
        {title && (
          <Typography variant="h2" cssClass="information-grid-title title-bold-md">
            {title}
          </Typography>
        )}
        {description && (
          <div className={`information-grid-description text-gray-100`}>{ReactHtmlParser(description)}</div>
        )}
        <div>
          <Row className="justify-content-between">
            {data.items.map((item, index) => (
              <Col sm="12" md="6" lg="4" className="mb-4" key={get(item, 'entity.id')}>
                <InfoCard
                  id={get(item, 'entity.id')}
                  theme={get(item, 'entity.theme.entity.classes')}
                  title={get(item, 'entity.title')}
                  subtitle={get(item, 'entity.subtitle')}
                  ctaText={get(item, 'entity.button.entity.link.title')}
                  url={get(item, 'entity.button.entity.link.url.path')}
                  image={
                    isMobile
                      ? get(item, 'entity.media.entity.images.medium.url')
                      : get(item, 'entity.media.entity.images.wide.url')
                  }
                  icon={isMobile ? '' : get(item, 'entity.button.entity.linkType.entity.token')}
                  index={index}
                />
              </Col>
            ))}
          </Row>
        </div>
        {buttonTitle && (
          <div className="card-cta-btn pb-2">
            <CustomButton
              text={buttonTitle}
              iconAlign="right"
              icon={get(data, 'button.entity.linkType.entity.token') || 'arrow-right'}
              onClick={() => {
                startsWithHttp(buttonLinkUrl) ? window.open(buttonLinkUrl) : history.push(buttonLinkUrl)
              }}
            />
          </div>
        )}
      </Container>
    </Container>
  )
}

export default InformationGrid
